import Cookies from 'js-cookie'

import axios from '../../utils/axios'
import { servicingApi } from '../../config'
import { getSavedProperties, clearSavedProperties } from '../properties/actions'
import { getHubspotProperties, submitSignUpForm } from '../../utils/hubspot'
import { adwords, fbq, ga } from '../analytics/analytics'
import { bugsnagClient } from '../../utils/bugsnag'

export const CLEAR_AUTH_USER = 'CLEAR_AUTH_USER'
export const RECEIVED_AUTH_USER = 'RECEIVED_AUTH_USER'
export const CLOSE_AUTH_MODAL = 'CLOSE_AUTH_MODAL'
export const OPEN_AUTH_MODAL = 'OPEN_AUTH_MODAL'
export const RECEIVED_FIREBASE_USER = 'RECEIVED_FIREBASE_USER'

export const receivedAuthUser = authUser => {
  if (authUser) {
    window.analytics.identify(authUser.id, {
      name: `${authUser.first_name} ${authUser.last_name}`,
      email: authUser.email
    })

    bugsnagClient.user = {
      email: authUser.email,
      id: authUser.id
    }
  }

  return {
    type: RECEIVED_AUTH_USER,
    authUser
  }
}

export const receivedFirebaseUser = firebaseUser => ({
  type: RECEIVED_FIREBASE_USER,
  firebaseUser
})

export const closeAuthModal = success => {
  return (dispatch, getState) => {
    if (success) {
      const onSuccess = getState().auth.onSuccess
      onSuccess && onSuccess()
    }

    dispatch({ type: CLOSE_AUTH_MODAL })
  }
}

export const openAuthModal = options => ({
  type: OPEN_AUTH_MODAL,
  options
})

export const createOrFetchUser = idToken => {
  return async dispatch => {
    const res = await axios
      .post(`${servicingApi}/users/create_or_fetch`,
        { firebase_id_token: idToken })

    const user = res.data

    const hubspotProperties = await getHubspotProperties(user.email)

    if (!hubspotProperties && user.phone) {
      await submitSignUpForm({
        hubspotutk: Cookies.get('hubspotutk'),
        pageUrl: window.location.href,
        pageName: 'Homevest Authorized Registration'
      })
    }

    dispatch(receivedAuthUser(user))
    dispatch(getSavedProperties())

    return user
  }
}

export const createUser = idToken => {
  return dispatch => {
    return axios.post(`${servicingApi}/users/create_or_fetch`, {
      firebase_id_token: idToken
    })
  }
}

export const updateUser = update => {
  return async (dispatch, getState) => {
    try {
      const res = await axios
        .post(`${servicingApi}/users`, update)

      if (update.phone) {
        fbq('track', 'SignupLead')
        fbq('track', 'AnyLead')
        ga('send', 'event', 'Signup', 'Complete')
        adwords('AMrbCLDY7X0Q4MKGjwM')
      }

      const user = res.data

      dispatch(receivedAuthUser(user))
      dispatch(getSavedProperties())

      return user
    } catch (err) {
      throw new Error(err.response.data.message)
    }
  }
}

export const clearAuthUser = () => {
  return async dispatch => {
    dispatch({
      type: CLEAR_AUTH_USER
    })

    dispatch(clearSavedProperties())
  }
}
